import { render, staticRenderFns } from "./OrdersSection.vue?vue&type=template&id=24c35449&scoped=true"
import script from "./OrdersSection.vue?vue&type=script&lang=js"
export * from "./OrdersSection.vue?vue&type=script&lang=js"
import style0 from "./OrdersSection.vue?vue&type=style&index=0&id=24c35449&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c35449",
  null
  
)

export default component.exports